module.exports = __webpack_public_path__ + "img/mingbai5_5f4b43dac.png";